module.exports = __webpack_public_path__ + "static/img/sivney.72006dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/sivney.png
// module id = Vxfp
// module chunks = 0